import _ from "lodash";
import {COLOR_LIST} from "../constants/color.constant";

const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

export {
    processColorDetails,
    getColorHexCode,
}

const processColorDetails = (parentDetail) => {
    if (parentDetail.colorKey && parentDetail.colorCodeKey) {
        const color = colorMap[parentDetail.colorKey];
        const colorCodeMap = _.keyBy(color.colorCodes, 'colorCodeKey');
        const colorCode = colorCodeMap[parentDetail.colorCodeKey];

        if (colorCode) {
            parentDetail.hexCode = colorCode.hexCode;
            parentDetail.fill = colorCode.hexCode;
        }
    }

    if (parentDetail.strokeColorKey && parentDetail.strokeColorCodeKey) {
        const color = colorMap[parentDetail.strokeColorKey];
        const colorCodeMap = _.keyBy(color.colorCodes, 'colorCodeKey');
        const colorCode = colorCodeMap[parentDetail.strokeColorCodeKey];

        if (colorCode) {
            parentDetail.strokeHexCode = colorCode.hexCode;
            parentDetail.stroke = colorCode.hexCode;
        }
    }

    if (parentDetail.shadowColorKey && parentDetail.shadowColorCodeKey) {
        const color = colorMap[parentDetail.shadowColorKey];
        const colorCodeMap = _.keyBy(color.colorCodes, 'colorCodeKey');
        const colorCode = colorCodeMap[parentDetail.shadowColorCodeKey];

        if (colorCode) {
            parentDetail.shadowColor = colorCode.hexCode;
        }
    }

    if (parentDetail.backgroundColorKey || parentDetail.backgroundColorCodeKey) {
        const color = colorMap[parentDetail.backgroundColorKey];

        if (color) {
            const colorCodeMap = _.keyBy(color.colorCodes, 'colorCodeKey');
            const colorCode = colorCodeMap[parentDetail.backgroundColorCodeKey];

            if (colorCode) {
                parentDetail.backgroundColor = colorCode.hexCode;
            } else {
                parentDetail.backgroundColor = '';
            }
        } else {
            parentDetail.backgroundColor = '';
        }
    }
}


const getColorHexCode = (parentDetail, colorKeyAttribute, colorCodeKeyAttribute) => {
    let colorHexCode = '';
    const color = colorMap[parentDetail[colorKeyAttribute]];

    if (color) {
        const colorCodeMap = _.keyBy(color.colorCodes, 'colorCodeKey');
        const colorCode = colorCodeMap[parentDetail[colorCodeKeyAttribute]];

        if (colorCode) {
            colorHexCode = colorCode.hexCode;
        }
    }

    return colorHexCode;
}
